class helper {
    static handleDescription(description: string, length: number) {
        if (description.length > length) {
            return description.substring(0, length) + '...';
        } else {
            return description;
        }
    }

    static transformListItems = (html: string) => {
        return html
            .replace(/<ul>/g, '<ul class="list-inside list-disc pl-4">')
            .replace(/<ol>/g, '<ol class="list-inside list-decimal pl-4">')
            .replace(/<li>/g, '<li class="pl-4">');
    };

    static convertToSlug = (text: string) => {
        return text
            .toLowerCase()
            .replace(/ /g, '-')
            .replace(/[^\w-]+/g, '');
    }
}

export default helper;